import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getPageContentBenefits } from '../../../../entities/PageContent'
import { PageSection } from '../../../../shared/ui/PageSection'
import cls from './BenefitsSection.module.scss'

type Benefit = { title: string; desc: string; icon?: string }

const FALLBACK_ICONS = ['🛣️', '🚙', '🛏️', '🍳', '🔥', '⛺']

export const BenefitsSection: React.FC = () => {
    const { t, i18n } = useTranslation()
    const benefitsSection = useSelector(getPageContentBenefits)
    const fallbackItems = t('benefits.items', {
        returnObjects: true
    }) as Benefit[]
    const lang = i18n.language.split('-')[0]
    const isRu = lang === 'ru'

    const title = benefitsSection
        ? isRu
            ? benefitsSection.titleRu
            : benefitsSection.titleEn
        : t('benefits.title')
    const items: Benefit[] =
        benefitsSection?.items?.map((item) => ({
            title: isRu ? item.titleRu : item.titleEn,
            desc: isRu ? item.descriptionRu : item.descriptionEn,
            icon: item.icon ?? undefined
        })) ?? fallbackItems

    return (
        <PageSection
            title={title}
            align="start"
            style={{ backgroundColor: 'var(--bg-base)' }}
        >
            <div className={cls.grid}>
                {items.map((benefit, idx) => (
                    <div
                        key={benefitsSection?.items?.[idx]?.id ?? idx}
                        className={cls.card}
                    >
                        <div className={cls.iconWrap}>
                            {benefit.icon ?? FALLBACK_ICONS[idx] ?? '✦'}
                        </div>
                        <p className={cls.title}>{benefit.title}</p>
                        <p className={cls.desc}>{benefit.desc}</p>
                    </div>
                ))}
            </div>
        </PageSection>
    )
}

export default BenefitsSection
